import {observable, action, computed, toJS} from 'mobx';

import * as socialApi from './../socialApi';

class UnapprovedPostsStore {

  @observable
  posts = [];

  @observable
  originalPosts = {}; // map of post ID -> post, of posts which those ^^ are replying to

  @observable
  postCount = 0;

  @computed
  get postCountNeedingDecision() {
    return this.posts.filter(p => !p.rejectedForPublishing).length
  }

  @observable
  loading = false;

  loadMore(reset = false) {
    if (this.loading) return;

    this.loading = true;
    if (reset) {
      this.posts = [];
    }

    socialApi.postsNeedingApproval().then(action("savePosts", response => {
      this.posts = this.posts.concat(response.posts);
      this.originalPosts = {...this.originalPosts, ...response.originalPosts};
      this.postCount = response.count;
      this.loading = false;
    }))
  }

  @action
  updatePost(post) {
    return socialApi.updatePost(post).then(action("removeApprovedPost", updated => {
      this.posts = this.posts.map(p => p._id === updated.post._id ? updated.post : p)
                             .filter(post => post.requiresApproval);
      this.postCount = this.posts.length;
      return updated.post;
    }))
  }

  @action
  createPost(post) {
    return socialApi.createPost(post).then(action("addPost", newPost => {
      const postToBePublished  = newPost.post.postToBePublished;
      this.posts = this.posts.concat(postToBePublished).filter(post => post.requiresApproval);
      this.postCount = this.posts.length;
      return post;
    }))
  }

  @action
  deletePost(post){
    return socialApi.deletePost(post).then(action("deletePost", () => {
      this.posts = this.posts.filter(p => p._id !== post._id);
      this.postCount = this.posts.length;
    }));
  }

  saveNote(post, note) {
    return socialApi.saveNote(post, note).then(action("updatePost", updated => {
      this.posts = this.posts.map(p => p._id === updated.post._id ? updated.post : p).filter(post => post.requiresApproval);
      return updated.post;
    }))
  }
}

export default new UnapprovedPostsStore()
